module.exports = __webpack_public_path__ + "static/media/m.c2f8791a.svg";